var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    attrs: {
      variant: _vm.isMobile ? "mobile-swipe" : "drawer",
      "custom-footer": "",
      customClass: "room-upgrade-modal",
    },
    on: { input: _vm.handleOpenModal, close: _vm.handleCloseModal },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var activate = ref.activate
            return [_vm._t("default", null, null, { activate: activate })]
          },
        },
        {
          key: "header",
          fn: function () {
            return [
              _c("div", { staticClass: "modal-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.tc("booking.upgradeRoom")))]),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function (ref) {
            var isActive = ref.isActive
            return [
              _c(
                "roomUpgradeModalBody",
                _vm._b(
                  {},
                  "roomUpgradeModalBody",
                  { isActive: isActive },
                  false
                )
              ),
            ]
          },
        },
        {
          key: "footer",
          fn: function (ref) {
            var deactivate = ref.deactivate
            return [_c("roomUpgradeModalFooter", { on: { close: deactivate } })]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }